module.exports = __webpack_public_path__ + "static/media/sos-humanas.3da6590e.png";